var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sort-link",on:{"click":function($event){_vm.notifySort();
    _vm.sortList(_vm.filteredList, _vm.list, _vm.column, _vm.secondColumn);}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }